import React, { useEffect, useRef, useState } from 'react';
import { Chart } from 'react-google-charts';
import api from '../api';

type SaleItem = {
    id: number;
    item: string;
    state: string;
    release_date?: string;
    start_date?: string;
    end_date?: string;
    sale: {
        id: number;
        contract_date: string;
        company: { id: number; name: string };
        site: { id: number; name: string };
    };
};

const validStates = ['대기', '생산', '생산완료'];

const DocumentSchedule: React.FC = () => {
    const [data, setData] = useState<any[][]>([
        ['업체 / 현장 / 품목', '상태', 'Start', 'End', { role: 'style' }],
    ]);

    const chartRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        (async () => {
            try {
                const resp = await api.get<SaleItem[]>('/api/sale-items');

                const rows = resp.data
                    .filter(
                        (i) =>
                            validStates.includes(i.state) &&
                            i.start_date &&
                            i.end_date
                    )
                    .map((i) => {
                        const group = `${i.sale.company.name} / ${i.sale.site.name} / ${i.item}`;
                        const label = `(${i.state})`;
                        const start = new Date(i.start_date!);
                        const end = new Date(i.end_date!);

                        let color = '#888';
                        if (i.state === '대기') color = '#f4c20d';
                        if (i.state === '생산') color = '#4285F4';
                        if (i.state === '계산서발행' || i.state === '생산 완료')
                            color = '#34A853';

                        return [group, label, start, end, color];
                    })
                    .sort((a, b) => (a[0] as string).localeCompare(b[0] as string));

                setData([
                    ['업체 / 현장 / 품목', '상태', 'Start', 'End', { role: 'style' }],
                    ...rows,
                ]);
            } catch (e) {
                console.error('데이터 로드 실패', e);
            }
        })();
    }, []);

    const handlePrint = () => {
        const printContents = chartRef.current?.innerHTML;
        const printWindow = window.open('', '', 'width=1200,height=800');
        if (printWindow && printContents) {
            printWindow.document.write(`
                <html>
                    <head>
                        <title>생산 스케줄</title>
                        <style>
                            @page { size: A4 landscape; margin: 10mm; }
                            body { margin: 0; }
                            .chart-wrapper { 
                                width: 100%; 
                                zoom: 0.75; 
                                font-family: sans-serif;
                            }
                        </style>
                    </head>
                    <body>
                        <div class="chart-wrapper">
                            ${printContents}
                        </div>
                    </body>
                </html>
            `);
            printWindow.document.close();
            printWindow.focus();
            printWindow.print();
            printWindow.close();
        }
    };

    return (
        <>
            <div style={{ textAlign: 'right', marginBottom: '8px', marginRight: '30px' }}>
                <button onClick={handlePrint}>프린트</button>
            </div>

            <div ref={chartRef}>
                <Chart
                    width="99.5%"
                    height="600px"
                    chartType="Timeline"
                    loader={<div>로딩 중…</div>}
                    data={data}
                    options={{
                        timeline: {
                            showRowLabels: true,
                            groupByRowLabel: true,
                        },
                        hAxis: {
                            format: 'M/d',
                            gridlines: { count: 15 },
                        },
                        tooltip: { isHtml: true },
                    }}
                />
            </div>
        </>
    );
};

export default DocumentSchedule;